"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openLink = void 0;
const openLink = (url) => {
    if (!url) {
        alert("Link not available.");
        return;
    }
    if (confirm("This will open the link in a new tab")) {
        window.open(url, "_blank");
    }
};
exports.openLink = openLink;
//# sourceMappingURL=openLink.js.map